import React from 'react'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'tokens'
import AppointmentCard from '../../../../components/AppointmentCard/AppointmentCard'
import { shouldShowGreenBg } from '../../../../utils/shouldShowGreenBg'
import { getVisitBadges } from '../getVisitBadges'
import { ColumnCard, ColumnHeader, Title, Count, TimeSection, ColumnContent } from '../index.styled'

export default function PreviousPanel({ data }: { data: any }) {
  const navigate = useNavigate()
  return (
    <ColumnCard>
      <ColumnHeader>
        <Title>Previous</Title>
        <Count>{data.length}</Count>
      </ColumnHeader>
      <ColumnContent>
        <TimeSection>
          {data.map((d: any) => (
            <AppointmentCard
              key={d.visit?.id || d.visitId}
              name={`${d.visit?.patient?.user?.firstname || ''} ${d.visit?.patient?.user?.lastname || ''}`.trim()}
              avatar={d.visit?.patient?.user?.profilePic || undefined}
              badges={getVisitBadges(d, { isUpcomingOrCheckedIn: false })}
              onClick={() => {
                navigate(`/patient-detail/${d.visit?.id}`)
              }}
              cardStyle={{
                backgroundColor: shouldShowGreenBg(d) ? COLORS.primary : '',
              }}
              nameStyle={{
                color: shouldShowGreenBg(d) ? COLORS.textSecondary : '',
              }}
            />
          ))}
        </TimeSection>
      </ColumnContent>
    </ColumnCard>
  )
}
